import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { DdConsentFormPage } from './dd-consent-form.page';
import { MasterHeaderModule } from '../../master-header/master-header.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MasterHeaderModule,
    RouterModule.forChild([{ path: '', component: DdConsentFormPage }])
  ],
  declarations: [DdConsentFormPage],
  exports: [DdConsentFormPage]
})
export class DdConsentFormPageModule {}
